// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__LG9ei","headers":"hero_headers__21KQN","actions":"hero_actions__qll6P","learnMore":"hero_learnMore__GU15C","animation":"hero_animation__WShjB"};